module.exports = __webpack_public_path__ + "img/language_color_24dp.3471965d.svg";